/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const BlueBg = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: token('color.background.brand.bold'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
  height: token('space.300'),
  width: token('space.300'),
});

export const DarkBg = styled(BlueBg)({
  backgroundColor: token('color.background.neutral.bold'),
});

export const PopupMenuHeader = styled.h3({
  padding: `${token('space.300')} ${token('space.300')} ${token(
    'space.100'
  )} ${token('space.250')}`,
});
